<template lang="pug">
  .product
    template(v-for="product in products")
      .product-intro(v-if="path === product.name")
        template(v-if="product.name !== 'KettleBell-Advanced'")
          h1.product-title {{ product.name }}
        template(v-else)
          h1.product-title(v-for="name in splitName(product.name)") {{ name }}
        p.product-info(v-html="product.description")

      .product-gallery(v-if="path === product.name")
        img.lazy(v-for="img in product.imgs" :data-src="img")
</template>

<script>
export default {
  props: ["products"],

  data() {
    return {
      path: this.$route.params.PName,
      currentView: this.$route.params.PName
    };
  },

  created() {
    this.lazyLoad = this.lazyLoad.bind(this);
  },

  mounted() {
    this.lazyLoad();

    document.addEventListener("scroll", this.lazyLoad);
    document.addEventListener("resize", this.lazyLoad);
    document.addEventListener("orientationChange", this.lazyLoad);
  },

  methods: {
    splitName(name) {
      const finalName = name.split("-");
      return finalName;
    },

    lazyLoad() {
      var lazyloadImages = document.querySelectorAll("img.lazy");
      var lazyloadThrottleTimeout;

      if (lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }

      lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function(img) {
          if (img.offsetTop < window.innerHeight + scrollTop) {
            img.src = img.dataset.src;
            img.classList.remove("lazy");
          }
        });
      }, 20);
    }
  },

  beforeDestroy() {
    document.removeEventListener("scroll", this.lazyLoad);
    document.removeEventListener("resize", this.lazyLoad);
    document.removeEventListener("orientationChange", this.lazyLoad);
  }
};
</script>

<style>
h1.product-title {
  margin: 0;
  padding: 0;
}
</style>
